import { memo, useCallback } from 'react';

import { SquareSlashIcon } from '@air/design-icons';

import { WorkspaceAgentActionsMenuKeyboardHint } from '~/components/v2/components/workspace/workspace-agent-panel/components/composer/actions-menu/WorkspaceAgentActionsMenuKeyboardHint';
import {
  WORKSPACE_AGENT_ACTIONS_MENU_SAVED_SKILLS_KEYBOARD_HINT,
  WORKSPACE_AGENT_ACTIONS_MENU_SAVED_SKILLS_LABEL,
} from '~/components/v2/components/workspace/workspace-agent-panel/constants/workspaceAgentActionsMenuLayout';
import { preserveWorkspaceAgentComposerFocus } from '~/components/v2/components/workspace/workspace-agent-panel/utils/preserveWorkspaceAgentComposerFocus';

export type WorkspaceAgentActionsMenuSavedSkillsRowProps = {
  onSelect: () => void;
};

export const WorkspaceAgentActionsMenuSavedSkillsRow = memo(
  ({ onSelect }: WorkspaceAgentActionsMenuSavedSkillsRowProps) => {
    const handleClick = useCallback(() => {
      onSelect();
    }, [onSelect]);

    return (
      <button
        className="flex w-full min-w-0 items-center gap-2 rounded-6 px-2 py-2 text-left text-12 leading-4 ads:hover:bg-hover-subtle hover:bg-gray-4"
        data-testid="WORKSPACE_AGENT_ACTIONS_MENU_SAVED_SKILLS"
        onClick={handleClick}
        onMouseDown={preserveWorkspaceAgentComposerFocus}
        type="button"
      >
        <SquareSlashIcon aria-hidden className="size-4 shrink-0 ads:text-icon-default text-gray-10" />
        <span className="min-w-0 flex-1 truncate ads:text-primary text-gray-12">
          {WORKSPACE_AGENT_ACTIONS_MENU_SAVED_SKILLS_LABEL}
        </span>
        <WorkspaceAgentActionsMenuKeyboardHint hint={WORKSPACE_AGENT_ACTIONS_MENU_SAVED_SKILLS_KEYBOARD_HINT} />
      </button>
    );
  },
);

WorkspaceAgentActionsMenuSavedSkillsRow.displayName = 'WorkspaceAgentActionsMenuSavedSkillsRow';
